import { baseApi } from "../api/baseApi";

export const serviceCatalogApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getServiceCatalog: build.query({
      query: () => ({
        url: "/api/service-catalog/services",
        method: "GET",
      }),
      transformResponse: (response) => (Array.isArray(response) ? response : []),
      providesTags: [{ type: "ServiceCatalog", id: "LIST" }],
    }),
    getServiceCodeMappings: build.query({
      query: () => ({
        url: "/api/service-catalog/service-code-mappings",
        method: "GET",
      }),
      transformResponse: (response) => (Array.isArray(response) ? response : []),
      providesTags: [{ type: "ServiceCatalog", id: "CODE_MAPPINGS" }],
    }),
    getServiceCodeMappingOptions: build.query({
      query: () => ({
        url: "/api/service-catalog/service-code-mapping-options",
        method: "GET",
      }),
      transformResponse: (response) => ({
        sourceTables: Array.isArray(response?.sourceTables) ? response.sourceTables : [],
      }),
      providesTags: [{ type: "ServiceCatalog", id: "CODE_MAPPING_OPTIONS" }],
    }),
    getServiceCodeMappingColumns: build.query({
      query: (sourceTable) => ({
        url: "/api/service-catalog/service-code-mapping-columns",
        method: "GET",
        params: { sourceTable },
      }),
      transformResponse: (response) => (Array.isArray(response) ? response : []),
    }),
    createServiceCatalogOffer: build.mutation({
      query: (body) => ({
        url: "/api/service-catalog/services",
        method: "POST",
        body,
      }),
      invalidatesTags: [
        { type: "ServiceCatalog", id: "LIST" },
        { type: "ServiceCatalog", id: "CODE_MAPPINGS" },
        "UserActivityEvents",
      ],
    }),
    updateServiceCatalogOffer: build.mutation({
      query: ({ serviceCode, body }) => ({
        url: `/api/service-catalog/services/${encodeURIComponent(serviceCode)}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: [{ type: "ServiceCatalog", id: "LIST" }, "UserActivityEvents"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetServiceCatalogQuery,
  useGetServiceCodeMappingsQuery,
  useGetServiceCodeMappingOptionsQuery,
  useGetServiceCodeMappingColumnsQuery,
  useCreateServiceCatalogOfferMutation,
  useUpdateServiceCatalogOfferMutation,
} = serviceCatalogApi;
